import * as React from 'react';
import { Model, Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Checkbox, FormControlLabel, styled, Typography } from '@material-ui/core';

export const TYPE = 'mui-checkbox';

export class MuiCheckboxModel extends Question {
  getType(): string {
    return TYPE;
  }

  get links() {
    return this.getPropertyValue('links');
  }
  set links(val) {
    this.setPropertyValue('links', val);
  }
}

const StyledFormControlLabel = styled(FormControlLabel)({
  alignItems: 'flex-start',
  '& p': {
    fontSize: 14,
    color: 'var(--black)'
  }
});
const StyledCheckbox = styled(Checkbox)({
  marginTop: -10
});

export class MuiCheckbox extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);

    const model = this.question.survey as Model;
    const links = this.getLinks();

    if (Array.isArray(links)) {
      links.forEach(({ variable }) => {
        if (variable) {
          const value = sessionStorage.getItem(variable);
          model.setVariable(variable, value === 'true');
        }
      });
    }
    this.calculateDisabled();

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  get question() {
    return this.questionBase;
  }

  getLinks() {
    return this.question.links;
  }

  handleChange({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) {
    this.question.value = checked;
  }

  handleClick(event: React.MouseEvent) {
    const model = this.question.survey as Model;
    const variableKey = (event.target as HTMLElement).getAttribute('data-variable');

    if (event.button === 2) return;

    if (variableKey) {
      model.setVariable(variableKey, true);
      sessionStorage.setItem(variableKey, 'true');
      this.calculateDisabled();
    }
  }

  handleContextMenu(event: React.MouseEvent) {
    event.preventDefault();
  }

  calculateDisabled() {
    const model = this.question.survey as Model;
    const links = this.getLinks();
    let value = false;

    if (Array.isArray(links)) {
      value = links.map(({ variable }) => model.getVariable(variable)).some((value?: boolean) => value === false);
    }
    this.question.setPropertyValue('disabled', value);
  }

  protected renderElement(): JSX.Element | null {
    const { title, value = '' } = this.question;
    const links = this.getLinks();
    let titleReplaced = title;
    const disabled = this.question.getPropertyValue('disabled');

    if (Array.isArray(links)) {
      links.forEach(({ text, href, variable }, index) => {
        titleReplaced = titleReplaced.replace(
          `{${index}}`,
          `<a class="checkbox-link" target="_blank" href="${href}" data-variable="${variable}" rel="noopener noreferrer">${text}</a>`
        );
      });
    }

    return (
      <StyledFormControlLabel
        checked={value === true}
        onChange={this.handleChange}
        control={<StyledCheckbox color="primary" />}
        label={
          <Typography
            dangerouslySetInnerHTML={{ __html: titleReplaced }}
            onMouseUp={this.handleClick}
            onContextMenu={this.handleContextMenu}
          />
        }
        disabled={disabled}
      />
    );
  }
}
